import { Component, inject, OnInit } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { distinctUntilChanged, filter, map, take } from 'rxjs/operators';
import { PowerBIEmbedModule } from 'powerbi-client-angular';
import { Store } from '@ngrx/store';
import { selectPowerBIIsLoaded, selectReports } from '@store/selectors/power-bi/power-bi.selectors';

@Component({
  selector: 'app-power-bi-report-viewer',
  imports: [PowerBIEmbedModule, AsyncPipe],
  templateUrl: './power-bi-report-viewer.component.html',
  styleUrl: './power-bi-report-viewer.component.css',
})
export class PowerBiReportViewerComponent implements OnInit {
  private readonly store = inject(Store);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  report$ = combineLatest([
    this.store.select(selectReports),
    this.route.paramMap,
  ]).pipe(
    map(([reports, paramMap]) => {
      const reportId = paramMap.get('reportId');
      return reports?.find(report => report.reportId === reportId) ?? null;
    }),
    distinctUntilChanged((prev, curr) => prev?.reportId === curr?.reportId),
    map(report => {
      if (!report) return null;
      return { ...report, embedConfiguration: JSON.parse(JSON.stringify(report.embedConfiguration)) };
    })
  );

  readonly isLoaded$ = this.store.select(selectPowerBIIsLoaded);

  public reportClass = 'report-container';

  ngOnInit(): void {
    combineLatest([this.isLoaded$, this.report$]).pipe(
      filter(([isLoaded]) => isLoaded),
      take(1)
    ).subscribe(([, report]) => {
      if (!report) {
        this.router.navigate(['/bi']);
      }
    });
  }
}
